// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"ea116182","424":"9ea8fa26","453":"55c7ed53","551":"d9f44201"}[chunkId] + ".chunk.js";
};